var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.00879,
    y: 90.2876,
    width: 26.0584,
    height: 4,
    rx: 2,
    transform: "rotate(-45 7.00879 90.2876)",
    fill: "#03447D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.7669,
    height: 4,
    rx: 2,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 90.0811 8.21509)",
    fill: "#03447D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.021 76.104C18.9442 71.0272 18.9442 62.796 24.021 57.7192L31.7992 49.9411L50.184 68.3258L42.4058 76.104C37.329 81.1808 29.0978 81.1808 24.021 76.104Z",
    fill: "#82C4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.104 25.0208C71.0272 19.9439 62.796 19.9439 57.7192 25.0208L49.9411 32.7989L68.3258 51.1837L76.104 43.4055C81.1808 38.3287 81.1808 30.0976 76.104 25.0208Z",
    fill: "#82C4FD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8198,
    y: 46.4058,
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "rotate(45 43.8198 46.4058)",
    fill: "#82C4FD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5981,
    y: 54.1838,
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "rotate(45 51.5981 54.1838)",
    fill: "#82C4FD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9707,
    y: 49.9412,
    width: 3,
    height: 30,
    rx: 1.5,
    transform: "rotate(-45 28.9707 49.9412)",
    fill: "#03447D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 30,
    rx: 1.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 49.9414 29.9707)",
    fill: "#03447D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8845 30.0821C67.9613 30.1617 68.9742 30.6238 69.7402 31.3849C71.2964 32.9412 71.4312 35.3902 70.0798 37.0228C70.8706 38.074 70.818 39.5638 69.8715 40.5103C68.8324 41.5493 67.1379 41.5106 66.0878 40.4605L60.9353 35.308C59.736 34.1087 59.6932 32.1752 60.878 30.9904C61.898 29.9704 63.4751 29.8582 64.6588 30.6137C65.2408 30.1972 66.0595 30.0207 66.8845 30.0821Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9557 28.5932L21.8407 20.795C21.3495 20.2567 21.3877 19.422 21.9261 18.9308C22.4644 18.4396 23.2991 18.4779 23.7903 19.0162L30.9053 26.8144C31.3965 27.3527 31.3582 28.1874 30.8199 28.6786C30.2815 29.1698 29.4469 29.1315 28.9557 28.5932Z",
    fill: "#00C2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9557 28.5932L21.8407 20.795C21.3495 20.2567 21.3877 19.422 21.9261 18.9308C22.4644 18.4396 23.2991 18.4779 23.7903 19.0162L30.9053 26.8144C31.3965 27.3527 31.3582 28.1874 30.8199 28.6786C30.2815 29.1698 29.4469 29.1315 28.9557 28.5932Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9561 39.7753L22.3187 39.6835C21.5904 39.6581 21.0205 39.0471 21.0459 38.3188C21.0712 37.5905 21.6823 37.0206 22.4106 37.0459L25.048 37.1378C25.7763 37.1632 26.3462 37.7742 26.3209 38.5025C26.2955 39.2308 25.6845 39.8007 24.9561 39.7753Z",
    fill: "#00C2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9561 39.7753L22.3187 39.6835C21.5904 39.6581 21.0205 39.0471 21.0459 38.3188C21.0712 37.5905 21.6823 37.0206 22.4106 37.0459L25.048 37.1378C25.7763 37.1632 26.3462 37.7742 26.3209 38.5025C26.2955 39.2308 25.6845 39.8007 24.9561 39.7753Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2166 24.5083L39.0822 19.3017C39.2017 18.5828 39.8812 18.0969 40.6001 18.2164C41.319 18.3359 41.805 19.0156 41.6855 19.7345L40.8199 24.9412C40.7004 25.6601 40.0207 26.1461 39.3018 26.0265C38.5829 25.907 38.0971 25.2272 38.2166 24.5083Z",
    fill: "#00C2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2166 24.5083L39.0822 19.3017C39.2017 18.5828 39.8812 18.0969 40.6001 18.2164C41.319 18.3359 41.805 19.0156 41.6855 19.7345L40.8199 24.9412C40.7004 25.6601 40.0207 26.1461 39.3018 26.0265C38.5829 25.907 38.0971 25.2272 38.2166 24.5083Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7844 68.9185L78.3633 76.2667C78.8865 76.7739 78.8995 77.6094 78.3922 78.1326C77.8849 78.6558 77.0494 78.6687 76.5262 78.1614L68.9473 70.8133C68.4241 70.3061 68.4112 69.4706 68.9185 68.9474C69.4257 68.4242 70.2612 68.4113 70.7844 68.9185Z",
    fill: "#00C2FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7844 68.9185L78.3633 76.2667C78.8865 76.7739 78.8995 77.6094 78.3922 78.1326C77.8849 78.6558 77.0494 78.6687 76.5262 78.1614L68.9473 70.8133C68.4241 70.3061 68.4112 69.4706 68.9185 68.9474C69.4257 68.4242 70.2612 68.4113 70.7844 68.9185Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8892 73.3735L62.0983 78.6474C62.1272 79.3756 61.5604 79.9893 60.8322 80.0182C60.104 80.0471 59.4903 79.4801 59.4614 78.752L59.2522 73.4779C59.2233 72.7497 59.7903 72.136 60.5185 72.1071C61.2466 72.0782 61.8603 72.6453 61.8892 73.3735Z",
    fill: "#00C2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8892 73.3735L62.0983 78.6474C62.1272 79.3756 61.5604 79.9893 60.8322 80.0182C60.104 80.0471 59.4903 79.4801 59.4614 78.752L59.2522 73.4779C59.2233 72.7497 59.7903 72.136 60.5185 72.1071C61.2466 72.0782 61.8603 72.6453 61.8892 73.3735Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8456 60.2778L80.0053 61.389C80.7178 61.5424 81.171 62.2443 81.0176 62.9567C80.8641 63.6691 80.1622 64.1223 79.4497 63.9689L74.2898 62.8577C73.5774 62.7043 73.1242 62.0023 73.2776 61.2899C73.4311 60.5775 74.1331 60.1244 74.8456 60.2778Z",
    fill: "#00C2FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8456 60.2778L80.0053 61.389C80.7178 61.5424 81.171 62.2443 81.0176 62.9567C80.8641 63.6691 80.1622 64.1223 79.4497 63.9689L74.2898 62.8577C73.5774 62.7043 73.1242 62.0023 73.2776 61.2899C73.4311 60.5775 74.1331 60.1244 74.8456 60.2778Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.f262d085d9f46bd5e755066f05e37d73.svg";
export { ForwardRef as ReactComponent };